import { StorageEnums } from 'app/storage-offer/storage-enum-values';
import * as angular from 'angular';

class StorageProductComponentFormComponentCtrl implements ng.IController {
    public enums = StorageEnums;

    $onInit() {}
}

angular.module('app').component('pkpStorageProductComponentForm', {
    controller: StorageProductComponentFormComponentCtrl,
    template:
        require('app/storage-offer/storage-product-component-form.component.html'),
    bindings: {
        productComponent: '<',
        componentDisabled: '<',
        outerForm: '<',
        productIndex: '<',
        productComponentIndex: '<',
        runtime: '<',
        onRemove: '&',
        offerRuntime: '<'
    }
});
